// extracted by mini-css-extract-plugin
export default {"external":"aZmeyK","tag":"bZmeyK","text":"cZmeyK","block":"dZmeyK"};